$(document).ready(function() {
    const section = $('[data-template-id]').data('template-id');
    let pageCount = $('[data-total-pages]').data('total-pages');
    function fetchProducts($params, $section, $page) {
        if (!$section) {
            $section = section
        }
        if (!$page) {
            $page = 1;
        }
        const sortBy = $('#SortBy').val();
        const url = `${window.location.pathname}?section_id=${$section}&${$params}&sort_by=${sortBy}&page=${$page}`;
        console.log(url);
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = $.parseHTML(responseText);
                let products = $(html).find('.collection-products').html();
                const filters = $(html).find('.plug-filter__items');
                const filterCount = $(html).find('[data-filters-count]').html();
                pageCount = $(html).find('[data-total-pages]').data('total-pages');
                $('[data-filters-count]').html(filterCount);
                if (filterCount > 0) {
                    $('.plug-facets__filter').addClass('plug-facets__filter--wActive');
                } else {
                    $('.plug-facets__filter').removeClass('plug-facets__filter--wActive');
                }
                console.log($params);
                if ($page == 1) {
                    $('.collection-products').html(products);
                } else {
                    $('.collection-products').append(products);
                }
                if ($page < pageCount) {
                    $page++;
                    fetchProducts($params, $section, $page);
                }
                theme.ajaxCartInit();
                updateFilters(filters);
                window.history.replaceState(null, document.title, window.location.pathname + '?' + $params + `&sort_by=${sortBy}`)
        });
    }
    function submitForm(form) {
        const params = $(form).serialize();
        fetchProducts(params, section);
    }

    function updateFilters(filters) {
        $(filters).find('.plug-filter__item').each(function() {
            const $this = $(this);
            let isShowFilterGroup = false;
            const $filterValues = $(this).find('.plug-filter__value');
            const filterGroupLength = $filterValues.length - 1;

            $filterValues.find('[data-filter-input]').each(function(index) {
                const count = $(this).data('filter-count');
                const id = $(this).data('filter-input');

                $(`[data-filter-input="${id}"]`).parents('[data-filter-value]').find('[data-filter-count-display]').html(count);
            });
        });
    }

    if (pageCount > 1) {
        for (i = 2; i <= pageCount; i++) {
            const params = $('[data-filter-form]').serialize()
            fetchProducts(params, section, i);
        }
    }

    updateFilters($('.plug-filter__items'));
    var details = [...document.querySelectorAll('details')];
    document.addEventListener('click', function(e) {
        if (!details.some(f => f.contains(e.target))) {
            details.forEach(f => f.removeAttribute('open'));
        } else {
            details.forEach(f => !f.contains(e.target) ? f.removeAttribute('open') : '');
        }
    })
    $(document).on('click', '.plug-filter-drawer__label', function(e) {
        $(this).siblings('.plug-filter-drawer__values').slideToggle();
        $(this).toggleClass('plug-filter-drawer__label--open');
    });
    $(document).on('click', '[data-filter-clear]', function(e) {
        $(`[data-filter-input]`).prop("checked", false);
        $('.plug-filter-drawer__label').removeClass('plug-filter-drawer__label--open');
        $('.plug-filter-drawer__values').slideUp();
        $('[data-selected-values]').html(' ');
        submitForm('[data-filter-form]');
    });
    $(document).on('click', '[data-remove-filter]', function(e) {
        const id = $(this).data('remove-filter');
        console.log(id);
        $(`[data-filter-input="${id}"]`).prop("checked", false);
        $(`[data-remove-filter="${id}"]`).parents('.plug-filter__active-value').remove();
        submitForm('[data-filter-form]');
    });
    $(document).on('change', '[data-sort-by-select]', function(e) {
        const $params = $('[data-filter-form]').serialize();
        const $grid = $('.shopify-section plug-product-grid');
        const gridId = $grid.attr('id');
        const $section = gridId;
        const sortBy = $(this).val();
        const url = `${window.location.pathname}?${$section}&${$params}&sort_by=${sortBy}`;
        console.log(url);
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = $.parseHTML(responseText);
                const products = $(html).find('.collection-products').html();
                const filters = $(html).find('.plug-filter__items');
                const filterCount = $(html).find('[data-filters-count]').html();
                $('[data-filters-count]').html(filterCount);
                console.log($params);
                $('.collection-products').html(products);
                theme.ajaxCartInit();
                updateFilters(filters);
                window.history.replaceState(null, document.title, window.location.pathname + '?' + $params + `&sort_by=${sortBy}`)
        });
    });
    $(document).on('change', '[data-filter-input]', function(e) {
        const id = $(this).data('filter-input');
        const value = $(this).val();
        console.log(id);
        if (this.checked) {
            $(`[data-filter-input="${id}"]`).prop("checked", true);
            $('[data-selected-values]').prepend(`
            <div class="plug-filter__active-value">
                ${value}
                <span data-remove-filter="${id}">
                    <svg class="icon icon--close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
            </div>
            `)
            submitForm('[data-filter-form]');
        }   else {
            $(`[data-filter-input="${id}"]`).prop("checked", false);
            $(`[data-remove-filter="${id}"]`).parents('.plug-filter__active-value').remove();
            submitForm('[data-filter-form]');
        }
    });
});
